import React, {createContext, useContext, useState, ReactNode} from 'react'
import {Loader} from '_uiComponents'

interface LoaderContextType {
    showLoader: () => void
    hideLoader: () => void
    isLoaderShowing: boolean
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined)

export const LoaderProvider = ({children}: {children: ReactNode}) => {
    const [isLoaderShowing, setIsLoaderShowing] = useState(false)

    const showLoader = () => {
        setIsLoaderShowing(true)
    }

    const hideLoader = () => {
        setIsLoaderShowing(false)
    }

    return (
        <LoaderContext.Provider value={{showLoader, hideLoader, isLoaderShowing}}>
            {children}
            {isLoaderShowing && <Loader />}
        </LoaderContext.Provider>
    )
}

export const useLoader = (): LoaderContextType => {
    const context = useContext(LoaderContext)
    if (!context) {
        throw new Error('useLoader must be used within a LoaderProvider')
    }
    return context
}
